import LongTermBanner from './LongTermBanner';

export default LongTermBanner;
